import { Directive } from '../decorators/Directive';
import { Input } from '../decorators/Input';
import { ITemplateRef } from '../ComponentRef';

@Directive('[case]')
export class DirectiveCase {
    @Input() case: any;
    @Input() content: ITemplateRef;

                    static ρAnn(): any {
                        return {"name":"DirectiveCase","params":{}};
                    }
               }


@Directive('[caseDefault]')
export class DirectiveCaseDefault {
    @Input() content: ITemplateRef;

                    static ρAnn(): any {
                        return {"name":"DirectiveCaseDefault","params":{}};
                    }
               }


@Directive('[switch]')
export class DirectiveSwitch {
    @Input() switch: any;
    @Input() cases: DirectiveCase[];
    @Input() caseDefault: DirectiveCaseDefault;

                    static ρAnn(): any {
                        return {"name":"DirectiveSwitch","params":{}};
                    }
               }
